module.exports = __webpack_public_path__ + "static/media/galerija_2016 (8).f001c053.jpg";